var lib_core      = require("lib-core");
var lib_geometry  = require("lib-geometry");

var Editor2DController = require("../editor2D/editor2DController.js");

var Camera2DView  = require("./camera2DView.js");
var Camera2DModel = require("./camera2DModel.js");

var Camera2DController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(Camera2DController, lib_core.Controller);
Camera2DController.inject = {
    editor2DController  : Editor2DController
};

module.exports = Camera2DController;

Camera2DController.prototype.createModel = function () {
    var editor2DModel = this.editor2DController.getModel();
    var camera2DModel = new Camera2DModel(editor2DModel);

    //TODO: temporary solution because viewS depends on grid units and initial scaling
    if(this.configuration.viewSmin) camera2DModel.viewSmin = this.configuration.viewSmin;
    if(this.configuration.viewSmax) camera2DModel.viewSmax = this.configuration.viewSmax;

    var defaultWorkPlane;
    if (this.configuration.defaultWorkPlane)
        defaultWorkPlane = new lib_geometry.BoundingBox(this.configuration.defaultWorkPlane[0],
                                           this.configuration.defaultWorkPlane[1],
                                           this.configuration.defaultWorkPlane[2],
                                           this.configuration.defaultWorkPlane[3]);
    else
        defaultWorkPlane = new lib_geometry.BoundingBox(0, 0, 400, 400);
    camera2DModel.defaultWorkPlane(defaultWorkPlane);

    // TODO: this is a really nasty hack!
    this.editor2DController.getModel().cameraModel = this.editor2DController.getModel().value("camera", false);
    this.editor2DController.getModel().cameraModel(camera2DModel);

    return camera2DModel;
};

Camera2DController.prototype.createView = function () {
    var editorView = this.editor2DController.getView();
    return new Camera2DView(this.getModel(), editorView);
};
